export default function useAvailableLocales() {
    const translation = useTranslation();
    return translation.getAvailableLocales().map((locale) => locale.locale);
}
